import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    inputEstBomper:{
        selector:"", 
        fileUrl: ""
    },
    inputEstCapot:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrio:{
        selector:"", 
        fileUrl: ""
    },
    inputEstGuargafandodelder:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPuertaCond:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPuertaTrasDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstEstriboDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstGradafangoTraDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstBomperTra:{
        selector:"", 
        fileUrl: ""
    },
    inputEstTapaBaul:{
        selector:"", 
        fileUrl: ""
    },
    inputEstGuardafangoTraIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPuertaTraIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPuertaCop:{
        selector:"", 
        fileUrl: ""
    },
    inputEstEstIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstGuardafangoDelIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstTecho:{
        selector:"", 
        fileUrl: ""
    },
    inputEstFarolaDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstFaolaIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstExpDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstExpIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstStopTra:{
        selector:"", 
        fileUrl: ""
    },
    inputEstLuzTraDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstTraIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPanoramico:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrioCond:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrioPasDer:{
        selector:"", 
        fileUrl: ""
    },
    inputEstPanoramicoTra:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrioPasIzq:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrioCop:{
        selector:"", 
        fileUrl: ""
    },
    inputEstVidrioSun:{
        selector:"", 
        fileUrl: ""
    }
};
const mutations = {
    updateField,
    updateRevision: (state, payload) => {
        if(payload.length !== 0){
            Object.keys(payload).forEach(key => {
                state[key] = payload[key];
            });
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
